import React,{Component} from 'react'
import MainPage from '../../components/fit_mini_portal/mainPage'
import {fitSalesData} from '../../data/fit-sales'

export default class Sales extends Component{
    render(){
        return <MainPage data={fitSalesData}/>
    }
}


// WEBPACK FOOTER //
// ./src/pages/solutions/sales.js